import React, { Component, Fragment } from 'react';
import classes from './StepOne.module.css';
import strings from '../../../../../assets/localization';
import config from '../../../../../constants/config';
import RadioGroup from '../../../../UI/RadioGroupIcon/RadioGroup';
import RadioGroupMulti from '../../../../UI/RadioGroupIconMulti/RadioGroup';
import Button from '../../../../UI/Button/Button';
import AppleLoginContainer from '../../../../../containers/Auth/AppleLogin/AppleLoginContainer';
import { isAlternateAuthAvailable } from '../../../../../assets/helpers/utils'; // getGenderInner, getSeekingGender,
import Spinner from '../../../../UI/Spinner/Spinner';

const { GENDER_OTHER } = config;
let optionsArrayGender = [];
let optionsArraySeeking = [];

export default class StepOne extends Component {
  constructor(props) {
    super(props);

    this.state = {
      optionsGender: [],
      optionsSeeking: [],
      showMoreOptions: true,
      autocomplete: null,
      seekingArr: [],
    };
  }

  componentDidMount() {
    this.setupGenders();

    if (!this.props.areGendersPreselectedFromUrlData) {
      // set up seeking from data
      if (this.props.seeking) {
        this.setSeekingData(this.props.seeking);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.gender !== this.props.gender ||
      prevProps.seeking !== this.props.seeking
    ) {
      this.setSeekingData(this.props.seeking);
    }
    if (
      prevProps.genderApiConfigDataLodaded !==
        this.props.genderApiConfigDataLodaded &&
      this.props.genderApiConfigDataLodaded === true
    ) {
      this.setSeekingData(this.props.seeking);
    }
    if (
      prevProps.getConfig.isFetching !== this.props.getConfig.isFetching &&
      this.props.getConfig.isFetching === false
    ) {
      this.setupGenders();
    }
  }

  setupGenders = () => {
    if (this.props.getConfig.status !== 'success') {
      this.setState({ optionsGender: [], optionsSeeking: [] });
      return;
    }
    const { genders_singular } = this.props.getConfig.response;

    if (GENDER_OTHER) {
      // let arr = [config.GENDER_ONE, config.GENDER_TWO, config.GENDER_OTHER]; // 3 is hidden in styles RadioGroupIcon/RadioGroup.css
      let arr = [1, 2, 3];
      optionsArrayGender = arr.map((e, i) => {
        return {
          value: i,
          // text: getGenderInner(e),
          text: genders_singular[e],
          gender: e,
        };
      });
      let arr2 = [1, 2, 3, 4]; // 3 is hidden
      optionsArraySeeking = arr2.map((e, i) => {
        return {
          value: i,
          // text: getSeekingGender(e),
          text: genders_singular[e === 4 ? 3 : e],
          seeking: e,
        };
      });
    } else {
      let arr = [config.GENDER_ONE, config.GENDER_TWO];
      optionsArrayGender = arr.map((e, i) => {
        return {
          value: i,
          // text: getGenderInner(e),
          text: genders_singular[e],
          gender: e,
        };
      });
      optionsArraySeeking = arr.map((e, i) => {
        return {
          value: i,
          // text: getSeekingGender(e),
          text: genders_singular[e === 4 ? 3 : e],
          seeking: e,
        };
      });
    }
    this.setState({
      optionsGender: optionsArrayGender,
      optionsSeeking: optionsArraySeeking,
    });
  };

  setGender = (value) => {
    const { optionsGender } = this.state;
    const index = optionsGender.findIndex((o) => o.value === value);
    const obj = optionsGender[index];

    this.props.setGenderAndSeeking({ gender: obj.gender });
  };

  setSeeking = (value) => {
    if (this.state.seekingArr[value] !== value + 1) {
      let newSeekingArr = [...this.state.seekingArr];
      newSeekingArr[value] = value + 1;

      this.setState({ seekingArr: newSeekingArr });
      let newSeekingValue = newSeekingArr.reduce((a, b) => a + b, 0);
      this.props.setGenderAndSeeking({ seeking: newSeekingValue });
    } else {
      let newSeekingArr = [...this.state.seekingArr];
      newSeekingArr[value] = 0;
      this.setState({ seekingArr: newSeekingArr });
      let newSeekingValue = newSeekingArr.reduce((a, b) => a + b, 0);

      if (newSeekingValue > 0) {
        this.props.setGenderAndSeeking({ seeking: newSeekingValue });
      } else {
        let newSeekingArr = [...this.state.seekingArr];
        newSeekingArr[value] = value + 1;
        this.setState({ seekingArr: newSeekingArr });
        newSeekingValue = newSeekingArr.reduce((a, b) => a + b, 0);
        this.props.setGenderAndSeeking({ seeking: newSeekingValue });
      }
    }
  };

  setSeekingData = (data) => {
    switch (data) {
      case 1:
        this.setState({ seekingArr: [1, 0, 0, 0] });
        break;
      case 2:
        this.setState({ seekingArr: [0, 2, 0, 0] });
        break;
      case 3:
        this.setState({ seekingArr: [1, 2, 0, 0] });
        break;
      case 4:
        this.setState({ seekingArr: [0, 0, 0, 4] });
        break;
      case 5:
        this.setState({ seekingArr: [1, 0, 0, 4] });
        break;
      case 6:
        this.setState({ seekingArr: [0, 2, 0, 4] });
        break;
      case 7:
        this.setState({ seekingArr: [1, 2, 0, 4] });
        break;
      default:
    }
  };

  render() {
    // console.log('StepOne render()', this.props, this.state);

    let secondRadioGroup;
    let content = null;
    let radioGroupWrapperOrientation = config.GENDER_OTHER
      ? classes.RadioGroupWrapperColumn
      : classes.RadioGroupWrapperRow;

    secondRadioGroup = (
      <RadioGroupMulti
        options={this.state.optionsSeeking}
        selected={this.state.seekingArr}
        radioClicked={this.setSeeking}
        largerRadio={config.GENDER_OTHER}
        isLandscape={this.props.isLandscape}
        hideThird
      />
    );

    // let nicheName = config.NICHE_SINGLES || config.NICHE_PLURAL.replace(/\w/, c => c.toUpperCase());
    let radioGroupOne;
    if (
      this.props.areGendersPreselectedFromUrlData &&
      this.props.genderApiConfigDataLodaded === false
    ) {
      radioGroupOne = (
        <RadioGroup
          options={this.state.optionsGender}
          selected={-1}
          radioClicked={this.setGender}
          largerRadio={config.GENDER_OTHER}
          isLandscape={this.props.isLandscape}
        />
      );
    } else {
      radioGroupOne = (
        <RadioGroup
          options={this.state.optionsGender}
          selected={this.props.gender - 1}
          radioClicked={this.setGender}
          largerRadio={config.GENDER_OTHER}
          isLandscape={this.props.isLandscape}
        />
      );
    }

    if (this.props.getConfig.status === 'success') {
      content = (
        <Fragment>
          <div>
            <div className={classes.LabelText}>{strings.iAm}</div>
            {radioGroupOne}
          </div>
          <div>
            <div className={classes.LabelText}>{strings.seeking}</div>
            {secondRadioGroup}
          </div>
        </Fragment>
      );
    } else {
      content = (
        <span className={classes.SpinnerWrapper}>
          <Spinner size='Small' />
        </span>
      );
    }

    return (
      <div className={classes.StepOne}>
        <div className={radioGroupWrapperOrientation}>{content}</div>
        <div className={classes.Footer}>
          <Button
            clicked={this.props.goToStep.bind(this, 2)}
            disabled={this.props.getConfig.status !== 'success'}
          >
            {strings.Find}
          </Button>
          {isAlternateAuthAvailable(this.props.getConfig) ? (
            <Fragment>
              <div className={classes.OrSeparation}>
                <div />
                <div className={classes.or}>{strings.or}</div>
                <div />
              </div>
              <AppleLoginContainer style={{ marginBottom: '1rem' }} />
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}
